var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(!['theme', 'hall', 'passport'].includes(_vm.$route.name))?_c('tab-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }